import React, { useContext, useState } from 'react'
import styled from 'styled-components'
import { TowingRecord } from '../../ViewTowingRecord/types'
import { AutoliittoSeparatorLine } from '../routes/subforms/styled'
import { RouteWrapper, BigButtonSection, Text } from '../../../../components/layout'
import { RouteHeader } from '../routes/subforms/RouteHeader'
import { Styling } from '../../../../components/Styling'
import { Button } from '../../../../components/Button'
import { Modal } from '../../../../components/Modal'
import { ACS } from '../../../../common/AccessControl'
import { EditRouteSubforms } from '../routes/types'
import { IconWrapper } from '../../../../components/notification/styles'
import { useHistoryPush } from '../../../../components/router'
import { createRouteMenuConfig, finishRouteAddressRequired } from '../routes/createRouteMenuConfig'
import { WarningNotification } from '../../../../components/notification/warningNotification'
import { TowingRecordType } from '../../../../common/types'
import { getIncompleteRoutes } from '../routes/getIncompleteRoutes'
import { useAlArcCodes } from '../../../../components/AlArcCodesForm'
import { arcCodeValidationError } from '../../../../components/ALSubForm/options'
import { useSettings } from '../../../Parameters'
import { StateStore } from '../../../StoreProvider'
import { isPaymentLinkPaid } from '../billing/TowingRecordBilling/types'

const RouteFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

interface EndTowingRecordProps {
  onCancel: () => void
  towingRecord: TowingRecord
  setNextForm: (id: EditRouteSubforms, type: 'end' | 'cancel') => void
}

export const EndTowingRecord: React.FunctionComponent<EndTowingRecordProps> = ({
  onCancel,
  towingRecord,
  setNextForm,
}) => {
   const { state: { currentUser } } = useContext(StateStore)
  const historyPush = useHistoryPush()
  const settings = useSettings()
  const [showCannotCancelModal, setShowCannotCancelModal] = useState<boolean>(false)
  const prepaymentPaid = isPaymentLinkPaid(towingRecord.paymentType, towingRecord.billing?.[0]?.status)
  const accessControl = new ACS(currentUser).setTowingRecord(towingRecord)
  const isAutoliitto = towingRecord.type === TowingRecordType.autoliitto
  const isSos = towingRecord.type === TowingRecordType.sos
  const { data: arcCodeLists, loading: loadingArcCodes } = useAlArcCodes({ skip: !isAutoliitto })

  const useExtendedRoutes = settings ? settings.modules.useExtendedRoutes : false

  const finishRouteRequired = finishRouteAddressRequired(towingRecord.jobDetails.serviceType, towingRecord.type)
  const routeMenuConfig = createRouteMenuConfig(
    towingRecord.routes,
    finishRouteRequired,
    towingRecord.type,
    useExtendedRoutes
  )

  const incompleteRoutes = getIncompleteRoutes(towingRecord, routeMenuConfig, useExtendedRoutes)
  const arcValidationError = arcCodeValidationError({ serviceType: towingRecord.jobDetails.serviceType, values: towingRecord }, arcCodeLists) 

  const canEndSosTowingRecord = isSos && accessControl.canTowingRecord('finalize')
  const canEndAutoliittoTowingRecord = isAutoliitto && incompleteRoutes.length === 0
  const disableEndTowingRecord = (isSos || isAutoliitto) && !canEndSosTowingRecord && !canEndAutoliittoTowingRecord

  return (
    <RouteFormContainer>
      <RouteWrapper>
        <RouteHeader label={`Lopeta työ`} regNo={towingRecord.vehicleDetails.registrationNumber} cancel={onCancel} disableEditRegNo />
        <Styling padding="0 2rem" paddingMobile="0 0.5rem">
          <BigButtonSection>
            <Button
              category="on"
              label="Lopeta työ"
              mobileLabel="Lopeta työ"
              onClick={() => {
                setNextForm('cancel-or-end-towing-record', 'end')
              }}
              size="m"
              fontWeight="normal"
              maxWidth="100%"
              dataTestId="end-towing-record-button"
              disabled={disableEndTowingRecord || !!arcValidationError || loadingArcCodes}
            />
            <Button
              category="cancel"
              label="Työ peruutettu"
              onClick={() => {
                if (prepaymentPaid) {
                  setShowCannotCancelModal(true)
                  return
                }
                setNextForm('cancel-or-end-towing-record', 'cancel')
              }}
              size="m"
              fontWeight="normal"
              maxWidth="100%"
            />
          </BigButtonSection>
          {showCannotCancelModal && (
            <Modal
              label="Työtä ei voi peruuttaa"
              message="Ennakkomaksu on jo maksettu maksulinkillä. Hyvitä maksu ensin, jotta voit peruuttaa työn."
              close={() => setShowCannotCancelModal(false)}
              closeLabel="OK"
            />
          )}
          <AutoliittoSeparatorLine marginTop="1rem" marginBottom="1rem" />
          {isSos && !accessControl.canTowingRecord('finalize') && (
            <Text style={{ fontWeight: 'bold', marginBottom: '1rem' }}>
              Huom! Paikan päällä suoritetussa työssä pitää olla kirjattu kohteen tiedot ja hinauksissa kohteen sekä
              määränpään tiedot ennen kuin työ voidaan merkitä valmiiksi
            </Text>
          )}
        </Styling>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {incompleteRoutes.map((r, i) => (
            <WarningNotification key={i} title={''} message={`${r.label} reittipisteeltä puuttuu tietoja`}>
              <IconWrapper className="w-100%">
                <Button
                  key={i}
                  onClick={() => historyPush(`/towing-record/${towingRecord.id}/${r.routeId}${r.subform}`)}
                  category={'new'}
                >
                  Muokkaa
                </Button>
              </IconWrapper>
            </WarningNotification>
          ))}
          {arcValidationError ? 
             <WarningNotification  title={''} message={arcValidationError}>
              <IconWrapper className="w-100%">
                <Button
                  onClick={() => {
                    if(useExtendedRoutes) {
                       historyPush(`/towing-record/${towingRecord.id}/finish?form=finished`)
                    }else  {
                       historyPush(`/towing-record/${towingRecord.id}/finish`)
                    }
                  }}
                  category={'new'}
                >
                  Muokkaa
                </Button>
              </IconWrapper>
            </WarningNotification> : null  
        }
        </div>
      </RouteWrapper>
    </RouteFormContainer>
  )
}

